


















































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import HsaLineChart from "@/shared/components/charts/HsaLineChart.vue";
import InvestmentLineChart from "@/shared/components/charts/InvestmentLineChart.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

@Component({
  components: {
    HsaLineChart,
    InvestmentLineChart,
    GenericLoadingSpinner
  }
})
export default class AccountBalanceWidget extends Vue {
  balanceStore = useHsaDailyBalanceStore();
  investmentBalanceStore = useInvestmentDailyBalanceStore();
  custodianSettingsStore = useCustodianSettingsStore();
  hsabInvestmentStore = useHsabInvestmentStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  formatCurrency = formatCurrency;

  mounted () {
    this.loadBalance();
    this.investmentThresholdStore.loadInvestmentThresholds({ username: this.username, partnerId: this.partnerId });
    this.custodianSettingsStore.getCustodianSettings({ username: this.username, partnerId: this.partnerId } as any);
    this.balanceStore.loadBalanceOnFile({ username: this.username, partnerId: this.partnerId });
    this.balanceStore.loadInstantBalance({ username: this.username, partnerId: this.partnerId });
  }
  @Watch("investmentThresholdStore.shouldLoadHsabInvestmentAccountStatus")
  loadHsaBankInvestment () {
    if (this.investmentThresholdStore.shouldLoadHsabInvestmentAccountStatus) {
      this.hsabInvestmentStore.loadInvestmentAccountStatus({ username: this.username, partnerId: this.partnerId });
    }
  }

  @Watch("$props", { deep: true })
  loadBalance () {
    this.investmentBalanceStore.loadCurrentDailyBalance({
      username: this.username,
      partnerId: this.partnerId
    });
  }

  get investmentBalanceToDisplay (): number {
    return this.investmentBalanceStore.sumOfAllInvestmentBalancesV2;
  }

  get isLoaded (): boolean {
    if (this.investmentThresholdStore.shouldLoadHsabInvestmentAccountStatus) {
      return this.investmentThresholdStore.thresholdsLoaded && this.hsabInvestmentStore.investmentAccountStatusLoaded;
    }

    return this.investmentThresholdStore.thresholdsLoaded;
  }

  get displayInvestments (): boolean {
    return this.investmentThresholdStore.displayInvestmentsSection ||
           this.investmentThresholdStore.displayLegacyHsabInvestmentsRedirectLink;
  }

  get widgetTabsArray () {
    if (this.displayInvestments) {
      return [{ title: "Cash" }, { title: "Investment" }];
    }

    return [{ title: "Cash" }];
  }

  get mostRecentCashBalanceDate (): string {
    if (this.balanceStore.instantBalance.amount) {
      return moment().format("MMM D, YYYY");
    }
    if (this.balanceStore.balanceOnFileDate) {
      return moment(this.balanceStore.balanceOnFileDate).format("MMM D, YYYY");
    }
    return "";
  }

  get cashAccountBalance (): number {
    return this.balanceStore.instantBalance.amount || this.balanceStore.balanceOnFileAmount;
  }

  get investmentBalanceDate (): string {
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      return null; // we don't display this for HSA Bank
    }
  // todo rcp check
    const date = this.investmentBalanceStore.singleCurrentBalance
        ? this.investmentBalanceStore.singleCurrentBalance.date
        : this.investmentBalanceStore.investmentBalanceOnFileDate as string;
    return moment(date).format("MMM DD");
  }
}
